module.exports = __webpack_public_path__ + "static/media/AvtomatSistTeploEnerOAOMosenergo.e76e02b7.pdf";